(function () {
    const STORAGE_KEY = 'wishlist';

    function getWishlist() {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    }

    function saveWishlist(list) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    }

    function toggleItem(product) {
        let list = getWishlist();
        const index = list.findIndex(p => p.handle === product.handle);

        if (index > -1) {
            list.splice(index, 1);
        } else {
            list.push(product);
        }

        saveWishlist(list);
    }

    document.addEventListener('click', function (e) {
        const btn = e.target.closest('.wishlist-btn');
        if (!btn) return;

        e.preventDefault();

        const product = {
            id: btn.dataset.productId,
            handle: btn.dataset.productHandle,
            title: btn.dataset.productTitle,
            url: btn.dataset.productUrl,
            image: btn.dataset.productImage
        };

        toggleItem(product);

        // redirige a la wishlist
        window.location.href = '/pages/wishlist';
    });
})();
